import { Box, Button, Modal } from "@mui/material";
import { useDashboardTheme } from "../../../context/DashboardThemeContext";

const EnterpriseModals = ({ openModal, preview, closePreview }) => {
  const { dashboardTheme } = useDashboardTheme();

  return (
    <Modal open={openModal} onClose={closePreview}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: dashboardTheme.card_background,
          p: { xs: 1.5, sm: 2 },
          borderRadius: "18px",
          border: `1px solid ${dashboardTheme.border_color}`,
          boxShadow:
            dashboardTheme.theme_mode === "dark"
              ? "0 24px 60px rgba(0,0,0,0.45)"
              : "0 24px 60px rgba(17,24,39,0.18)",
          textAlign: "center",
          width: "min(900px, calc(100vw - 28px))",
          maxHeight: "90vh",
          outline: "none",
        }}
      >
        <Box
          component="img"
          src={preview || ""}
          alt="Vista previa"
          sx={{
            maxWidth: "100%",
            maxHeight: "76vh",
            objectFit: "contain",
            borderRadius: "12px",
            bgcolor: dashboardTheme.dashboard_background,
          }}
        />

        <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
          <Button
            onClick={closePreview}
            variant="contained"
            sx={{
              height: 38,
              px: 2.4,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              bgcolor: dashboardTheme.button_color,
              color: dashboardTheme.button_text_color,
              boxShadow: "none",
              "&:hover": {
                bgcolor: dashboardTheme.button_hover_color || dashboardTheme.button_color,
                boxShadow: "none",
              },
            }}
          >
            Cerrar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EnterpriseModals;